import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, ArrowRight, Award, Check } from "lucide-react";
import { api } from "@/lib/api";
import { SITE } from "@/lib/site";
import SectionHeading from "@/components/SectionHeading";

export default function Barbers() {
  const [barbers, setBarbers] = useState([]);
  useEffect(() => { api.get("/barbers").then((r) => setBarbers(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="barbers-page" className="pt-32 pb-24 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <SectionHeading
          eyebrow="The House of Cuts"
          title="Masters of the chair."
          subtitle="Two masters. One unwavering standard. Pick your barber — or let us pick the right one for the look you want."
          testIdBase="barbers-header"
        />

        <div className="space-y-10 mt-14">
          {barbers.map((b, i) => {
            const reverse = i % 2 === 1;
            return (
              <article
                key={b.id}
                data-testid={`barber-card-${b.id}`}
                className={`card-monarch group grid lg:grid-cols-12 gap-0 overflow-hidden`}
              >
                <div className={`lg:col-span-5 img-zoom aspect-[4/5] lg:aspect-auto grayscale bg-monarch-black ${reverse ? "lg:order-2" : ""}`}>
                  <img src={b.image} alt={b.name} className="w-full h-full object-cover" />
                </div>
                <div className={`lg:col-span-7 p-7 md:p-12 flex flex-col justify-between ${reverse ? "lg:order-1" : ""}`}>
                  <div>
                    <div className="text-monarch-gold/40 font-serif text-3xl mb-2">{String(i + 1).padStart(2, "0")}</div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-monarch-gold mb-3">{b.role}</div>
                    <h3 className="font-serif text-3xl md:text-4xl text-monarch-cream leading-tight">{b.name}</h3>
                    <div className="mt-3 flex items-center gap-2 text-sm text-monarch-ash">
                      <Award className="w-3.5 h-3.5 text-monarch-gold" /> {b.experience} in the chair
                    </div>

                    {b.bio && (
                      <p className="mt-6 text-monarch-cream/85 leading-relaxed text-[15px] max-w-xl">{b.bio}</p>
                    )}

                    {b.works && b.works.length > 0 && (
                      <div className="mt-7">
                        <div className="eyebrow mb-4">Signature Work</div>
                        <ul className="grid sm:grid-cols-2 gap-y-2.5 gap-x-6 max-w-xl">
                          {b.works.map((w, k) => (
                            <li key={k} data-testid={`barber-${b.id}-work-${k}`} className="flex items-start gap-3 text-sm text-monarch-cream/85">
                              <Check className="w-4 h-4 text-monarch-gold shrink-0 mt-0.5" />
                              <span>{w}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="flex items-center gap-3 mt-8 pt-6 border-t border-monarch-gold/15">
                    <Link to="/book" data-testid={`barber-book-${b.id}`} state={{ barberId: b.id }} className="btn-gold !py-3 !px-5 text-[11px]">
                      Book with {b.name.split(" ")[0]} <ArrowRight className="w-3.5 h-3.5" />
                    </Link>
            <a href={SITE.social.instagram.url} target="_blank" rel="noreferrer" data-testid={`barber-ig-${b.id}`} className="w-10 h-10 border border-monarch-gold/30 hover:border-monarch-gold flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4 text-monarch-gold" />
            </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
